import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'
import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import {
  CPLUG_DELIVERY_FEATURE_FLAG,
  resolveOnlineStoreDestination
} from './isOnlineStoreMenuEnabled'
import useFeatureFlagStore from '~/domain/shared/feature-flag/stores/useFeatureFlagStore'

export function useOnlineStoreFeatureAccess (): void {
  const authStore = useAuthenticationStore()
  const featureFlagStore = useFeatureFlagStore()
  const { logged, companies } = storeToRefs(authStore)
  const route = useRoute()
  const router = useRouter()

  watch(
    () => ({
      logged: logged.value,
      companyId: companies.value[0]?.id ?? null
    }),
    (current, previous) => {
      if (!current.logged || current.companyId == null) {
        featureFlagStore.$reset()
        return
      }

      if (previous != null && previous.companyId !== current.companyId) {
        featureFlagStore.$reset()
      }

      featureFlagStore.fetch().catch(() => undefined)
    },
    { immediate: true }
  )

  watch(
    () => ({
      path: route.path,
      fetched: featureFlagStore.fetched,
      enabled: featureFlagStore.isEnabled(CPLUG_DELIVERY_FEATURE_FLAG)
    }),
    ({ path, fetched, enabled }) => {
      if (!fetched) {
        return
      }

      const destination = resolveOnlineStoreDestination(path, enabled)
      if (destination == null || destination === path) {
        return
      }

      Promise.resolve(router.replace(destination)).catch(() => undefined)
    }
  )
}
